import { createContext, Dispatch, SetStateAction, useCallback, useState, ReactNode} from 'react';
import { useHttpUtils } from '../Utilities/useHttpUtils';

interface LotCountContextInterface {
    ungradedLotCount: number, 
    readyToReviewCount: number,
    readyToGradeCount: number,
    updateCounters: () => void,
    lotList: string[],
    setLotList: Dispatch<SetStateAction<string[]>>;
}

const LotCountContext = createContext<LotCountContextInterface>({
    ungradedLotCount: 0,
    readyToGradeCount: 0,
    readyToReviewCount: 0,
    updateCounters: () => {},
    lotList: [],
    setLotList: () => {},
});

interface LotCountContextProviderProps {
    children: ReactNode
}

export const LotCountProvider = ({ children }: LotCountContextProviderProps) => {
    const [lotList, setLotList] = useState<string[]>([]);
    const [ungradedLotCount, setUngradedLotCount] = useState(0);
    const [readyToReviewCount, setReadyToReviewCount] = useState(0);
    const [readyToGradeCount, setReadyToGradeCount] = useState(0);
    const { fetchDataAuthenticated } = useHttpUtils();

    const getLotCounts = useCallback(() => {
        return fetchDataAuthenticated('/api/v1/lots/count')
            .then(response => {
                if (response.ok) {
                    return response.json();
                }

                throw new Error();
            })
            .then(count => {
                setUngradedLotCount(count.ungraded);
                setReadyToReviewCount(count.readyToReview);
                setReadyToGradeCount(count.readyToGrade);
            })
            .catch(() => console.error("Failed to retrieve lot counts"));
    }, [fetchDataAuthenticated]);

    return (
        <LotCountContext.Provider value={{ readyToReviewCount, readyToGradeCount, ungradedLotCount, updateCounters: getLotCounts, lotList, setLotList }}>
            {children}
        </LotCountContext.Provider>
    );
};

export default LotCountContext;